import React, { useState } from "react";
import "../styles/contact.css";
import bgImage from "../assets/bk6.jpg"; 

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    address: "",
    requirements: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Form submitted!");
  };

  return (
    <div className="contact_content_wrapper"
       style={{ backgroundImage: `url(${bgImage})` }}>
      
      {/* MAIN HEADING */}
      <h1 className="contact_main_title"
        style={{ paddingTop: "20px" }}>Contact Us</h1>
      <p className="contact_subtitle">
        We're here to assist you quickly and professionally.
      </p>

      {/* MAIN FLEX SECTION */}
      <div className="contact_section">

        {/* LEFT SIDE INFO */}
        <div className="contact_left">
          <h2 className="section_title">Get In Touch</h2>

          <div className="info_block">
            <h3>📍 Address</h3>
            <p>TPA bricks, (Near Theni District Court)</p>
            <p>Amma Patty, Vadaveeranayakanpatty</p>
            <p>Theni, Tamil Nadu - 625523</p>
          </div>

          <div className="info_block">
            <h3>📞 Contact Numbers</h3>
            <p>+91 7339416813</p>
            <p>+91 7339473368</p>
          </div>
          <div className="info_block">
            <h3>🕒 Working Hours</h3>
            <p>Monday – Sunday</p>
            <p>24/7 Open</p>
          </div>
        </div>

        {/* RIGHT SIDE FORM */}
        <div className="contact_right">
          <h2 className="section_title">Send a Message</h2>

          <form className="contact_form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              required
            />


            <textarea
              name="address"
              placeholder="Your Address"
              value={formData.address}
              onChange={handleChange}
              required
            />

            <textarea
              name="requirements"
              placeholder="Your Requirements (e.g., 10,000 bricks)"
              value={formData.requirements}
              onChange={handleChange}
              required
            />

            <button type="submit" className="submit_btn">Submit</button>
          </form>
        </div>
      </div>

      {/* MAP SECTION */}
      <div className="map_box">
        <h2 className="map_title">Find Us on Map</h2>

        <iframe
          title="TPA Bricks Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7468.412231051991!2d77.5217625080382!3d10.05069680247144!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b076adc4cb4ea7d%3A0x775e43c12de0368d!2s2GWG%2BJ9Q%2C%20Amma%20Patty%2C%20Vadaveeranaickenpatty%2C%20Tamil%20Nadu!5e1!3m2!1sen!2sin!4v1755131416678!5m2!1sen!2sin"
          width="100%"
          height="350"
          loading="lazy"
          style={{ border: "0" }}
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

    </div>
  );
}

export default Contact;
